import React from 'react'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { join, filter, compose, map, isNil, complement } from 'ramda'
import { timeFormat, eventDateFormat } from 'commons/date'
import momentTimezone from 'moment-timezone'

const useStyles = makeStyles((theme) => ({
  date: {
    color: theme.palette.notificationPreview.coralPink,
  },
}))

const NotificationEventDate = ({
  startDateTime,
  startTimezone,
  endDateTime,
  endTimezone,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const eventStartEnd = [
    { dateTime: startDateTime, timezone: startTimezone },
    { dateTime: endDateTime, timezone: endTimezone },
  ]

  const dateTimePreviewText = (date, time, timezone) =>
    formatMessage(
      { id: 'label.date.utc' },
      { date: date, time: time, offsets: timezone },
    )

  const dates = compose(
    map((m) =>
      dateTimePreviewText(
        momentTimezone(m.dateTime).tz(m.timezone).format(eventDateFormat),
        momentTimezone(m.dateTime).tz(m.timezone).format(timeFormat),
        momentTimezone.tz(m.timezone).format('Z'),
      ),
    ),
    filter(complement(isNil)),
  )(eventStartEnd)
  return (
    <div className="mt-8 mx-16">
      <span className={clsx(classes.date, 'font-base uppercase')}>
        {join(' - ', dates)}
      </span>
    </div>
  )
}

export default NotificationEventDate
